import React, {
    memo,
    useEffect,
} from 'react';

import { useSelector } from 'react-redux';

import _get from 'lodash/get';

import { useFeatures } from '@atc/features';

import { BuyerConnect } from 'reaxl-organisms';

import globalConfigsDuck from '@/ducks/globalConfigsDuck.js';
import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

const emptyArray = [];

const buyerConnectSimpleListingTypes = (listingTypes = []) => {
    if (listingTypes.length) {
        if (listingTypes.length === 1) {
            if (listingTypes[0] === 'NEW') {
                return 'new';
            }
            if (listingTypes[0] === 'CERTIFIED') {
                return 'cpo';
            }
            return 'used';
        }
        if (listingTypes.length === 2 && listingTypes.includes('USED') && listingTypes.includes('CERTIFIED')) {
            return 'used';
        }
    }
    // Intentionally returns undefined if combination of NEW and USED/CERTIFIED is selected or nothing is selected.
    return undefined;
};

function SRPBuyerConnectContainer() {
    const {
        buyer_connect: [isBuyerConnectEnabled] = [],
    } = useFeatures(['buyer_connect']);

    const buyerConnectUrl = useSelector(globalConfigsDuck.selectors.getBuyerConnectUrl);
    const labels = useSelector(srpFiltersDuck.selectors.getLabelsByValues);
    const filterValues = useSelector(srpFiltersDuck.selectors.getFiltersValues);

    const makeCodes = filterValues.makeCode || emptyArray;
    const makeCode = makeCodes.length === 1 ? makeCodes[0] : '';
    const zipCode = filterValues.zip;

    let makeLabel = '';
    let modelOrSeriesCode = '';
    let modelOrSeriesLabel = '';
    let trimCode = '';
    let trimLabel = '';

    if (makeCode) {
        makeLabel = _get(labels, ['makeCode', makeCode]);

        const modelCodes = filterValues[`modelCode|${makeCodes[0]}`] || emptyArray;
        const seriesCodes = filterValues[`seriesCode|${makeCodes[0]}`] || emptyArray;

        if (modelCodes.length === 1 || seriesCodes.length === 1) {
            modelOrSeriesCode = modelCodes[0] || seriesCodes[0];

            if (modelCodes[0]) {
                modelOrSeriesLabel = _get(labels, [`modelCode|${makeCode}`, modelOrSeriesCode], '');
            } else {
                modelOrSeriesLabel = _get(labels, [`seriesCode|${makeCode}`, modelOrSeriesCode], '');
            }

            const trimCodes = filterValues[`trimCode|${modelOrSeriesCode}`] || emptyArray;

            if (trimCodes.length === 1) {
                trimCode = trimCodes[0];

                trimLabel = _get(labels, [`trimCode|${modelOrSeriesCode}`, trimCode], []);
            }
        }
    }

    const listingTypes = filterValues.listingTypes || [];
    const listingType = buyerConnectSimpleListingTypes(listingTypes);

    const { endYear } = filterValues;

    useEffect(() => {
        const messageHandler = (
            {
                data,
                origin,
            }
        ) => {
            if (origin.match(/(^|\.)(autotrader|kbb)\.com(:\d+)?$/)
                && data
                && ['FDPQ_pageCall', 'UCPQ_pageCall'].includes(data.eventType)
                && ['fdpqthank', 'ucpqthank'].includes(data.stepName)) {
                const widgetType = data.stepName === 'fdpqthank' ? 'ncpq' : 'ucpq';
                global.optimizelyEdge = global.optimizelyEdge || [];
                global.optimizelyEdge.push({
                    type: 'event',
                    eventName: `${widgetType}_lead_submission`,
                });
            }
        };

        global.addEventListener('message', messageHandler);
        return () => {
            global.removeEventListener('message', messageHandler);
        };
    }, []);

    return isBuyerConnectEnabled && (
        <BuyerConnect
            year={endYear}
            zipCode={zipCode}
            makeCode={makeCode}
            makeLabel={makeLabel}
            modelCode={modelOrSeriesCode}
            modelLabel={modelOrSeriesLabel}
            trimCode={trimCode}
            trimLabel={trimLabel}
            pageName="fyc_srl"
            urlBase={buyerConnectUrl}
            listingType={listingType}
            initialHeight="378px"
        />
    );
}

export default memo(SRPBuyerConnectContainer);
